import React, { Fragment } from "react";

import { Ptag } from "components/core/fonts";
import {
  SplitCardTag,
  SplitDetailCardWrapper,
  SplitDetailWrapper,
  VerticalDivider,
} from "./styles";
import { colors, theme } from "theme";
import { capitalize } from "lodash";
import moment from "moment";

/**
 * A component that renders a select menu.
 * @param {object} props - The props object.
 * @param {string} props.title - Title of the card (optional).
 * @param {string} props.width - Width of card (optional)
 * @param {Array<details>} props.details - An array of objects containing number and title keys with string values.
 */

const SplitDetailCard = ({
  title,
  details,
  width,
  topHeading,
  last_updated,
}) => {
  const formatISODate = (date) => {
    return moment(date).format("DD/MM/YYYY");
  };
  return (
    <SplitDetailCardWrapper width={width}>
      <Ptag
        fontSize="14px"
        textAlign="center"
        fontWeight="700"
        color={`${colors.neoFontColor}`}
      >
        {title}
      </Ptag>
      {last_updated && (
        <Ptag
          opacity="0.8"
          fontWeight="500"
          marginTop="4px"
          fontSize="10px"
          color="#000000"
          textAlign="center"
        >
          as on <b>{formatISODate(last_updated)}</b>
        </Ptag>
      )}
      <SplitDetailWrapper>
        {details.map((detail, index) => (
          <Fragment key={index.toString()}>
            <div>
              <Ptag
                color={theme.neoFontColor}
                fontWeight="600"
                textAlign="center"
                fontSize="30px"
              >
                {detail.number}
              </Ptag>
              <Ptag
                marginTop="8px"
                fontWeight="700"
                textAlign="center"
                fontSize="12px"
              >
                {capitalize(detail.title)}
              </Ptag>
            </div>
            {index !== details.length - 1 && <VerticalDivider />}
          </Fragment>
        ))}
      </SplitDetailWrapper>
      {/* {topHeading && (
        <div style={{ display: "grid", placeItems: "center", marginTop: "1.4rem" }}>
          <SplitCardTag>
            {" "}
            <Ptag
              fontSize="12px"
              fontWeight="400"
              textAlign="center"
              color={colors.primaryColor}
            >
              {topHeading}
            </Ptag>
          </SplitCardTag>
        </div>
      )} */}
    </SplitDetailCardWrapper>
  );
};

export default SplitDetailCard;
